"use client";
import {
  Box,
  Button,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { Suspense, useContext } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { PlaceSearchContext } from "./contexts/place-search";
import { LoadingArea } from "@ui/loading";

export const DepPlaceInput = (props: any) => {
  return (
    <InputGroup
      w="full"
      {...props}
      my="4"
      zIndex="0"
      data-test="search-places-trigger"
    >
      <InputRightElement color="gray.600" pointerEvents="none" h="48px">
        <Button h="full" w="fit-content" colorScheme="green">
          Get Your Report
        </Button>
      </InputRightElement>
      <Input
        bg={"gray.50"}
        readOnly
        placeholder="Enter a zipcode, city, or address"
        cursor="pointer !important"
        sx={{
          display: "inline",
        }}
        fontSize="lg"
        _focus={{
          outline: "none",
        }}
        h="48px"
      />
    </InputGroup>
  );
};

DepPlaceInput.displayName = "DepPlaceInput";

export interface SearchTriggerProps {
  triggerType?: "icon" | "button" | "input" | "custom";
  CustomTrigger?: any;
}

export function SearchTrigger<T>({
  triggerType = "icon",
  CustomTrigger,
}: SearchTriggerProps) {
  const search = useContext(PlaceSearchContext);
  switch (triggerType) {
    case "icon":
      // @ts-ignore
      return (
        <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
          {search ? (
            <Icon
              as={IoSearchOutline}
              boxSize="1.25rem"
              onClick={search?.modal?.onOpen}
            />
          ) : (
            <></>
          )}
        </Suspense>
      );
    case "button":
      // @ts-ignore
      return (
        <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
          {search ? (
            <Box
              as="li"
              color={"blue.600"}
              fontWeight="bold"
              cursor="pointer"
              pr="4"
              onClick={() => search?.modal.onOpen()}
            >
              Search Your Area
            </Box>
          ) : (
            <></>
          )}
        </Suspense>
      );
    case "input":
      return (
        <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
          {search ? <DepPlaceInput onClick={search.modal.onOpen} /> : <></>}
        </Suspense>
      );
    case "custom":
      return (
        <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
          {search ? <CustomTrigger search={search} /> : <></>}
        </Suspense>
      );
    default:
      return (
        <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
          {search ? <CustomTrigger search={search} /> : <></>}
        </Suspense>
      );
  }
}
SearchTrigger.displayName = "SearchTrigger";
